import { render, staticRenderFns } from "./vnp-keyboard.vue?vue&type=template&id=fb385bae&scoped=true&"
import script from "./vnp-keyboard.vue?vue&type=script&lang=js&"
export * from "./vnp-keyboard.vue?vue&type=script&lang=js&"
import style0 from "./vnp-keyboard.vue?vue&type=style&index=0&id=fb385bae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb385bae",
  null
  
)

export default component.exports